/**
 * @generated SignedSource<<cfa15ad686deefe4d941538388b8259d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type EvaluationType = "TOP_PERFORMING" | "WORSE_PERFORMING" | "%future added value";
export type KPI = "AGGREGATE_CONVERSION_RATE" | "AVG_DAILY_PURCHASE_VOLUME" | "AVG_DAILY_SPEND" | "CLICK_THROUGH_RATE" | "CONVERSION_RATE" | "COST_PER_ADD_TO_CART" | "COST_PER_COMPLETED_REGISTRATION" | "COST_PER_DONATION" | "COST_PER_ENGAGEMENT" | "COST_PER_INITIATED_CHECKOUT" | "COST_PER_INSTALL" | "COST_PER_LANDING_PAGE_VIEW" | "COST_PER_LEAD" | "COST_PER_LINK_CLICK" | "COST_PER_PURCHASE" | "COST_PER_STORE_LOCATOR" | "COST_PER_TOTAL_PURCHASE" | "COST_PER_TRIAL_STARTED" | "CPM" | "ENGAGEMENT_RATE" | "HOOK_RATE" | "IMPRESSIONS" | "LANDING_PAGE_VIEW_RATE" | "LEAD_CONVERSION_RATE" | "LEAD_RATE" | "PURCHASES" | "PURCHASES_CONVERSION" | "PURCHASES_TO_IMPRESSIONS" | "PURCHASES_TO_LINK_CLICK" | "PURCHASES_TO_LPV" | "REACH" | "RESULT_RATE" | "ROAS" | "SPEND" | "TOTAL_ROAS" | "TRIALS_STARTED" | "TRIALS_STARTED_TO_IMPRESSIONS" | "WEBSITE_PURCHASES" | "%future added value";
export type LabelType = "DOMINANT_COLOR" | "HEADLINE" | "HOOK_TEXT" | "IMAGE" | "NOUN" | "PHRASE" | "TAG" | "THEME" | "VERB" | "VIDEO" | "%future added value";
export type GetAISummaryRequest = {
  aiDateRange: string;
  brandId: string;
  evaluationType: EvaluationType;
  kpi: KPI;
};
export type LabelTypeLiftGraphQuery$variables = {
  input: GetAISummaryRequest;
  skip: boolean;
};
export type LabelTypeLiftGraphQuery$data = {
  readonly getLabelLiftByType?: ReadonlyArray<{
    readonly labelType: LabelType;
    readonly lift: number | null;
  }>;
};
export type LabelTypeLiftGraphQuery = {
  response: LabelTypeLiftGraphQuery$data;
  variables: LabelTypeLiftGraphQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "LabelTypeLift",
        "kind": "LinkedField",
        "name": "getLabelLiftByType",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "labelType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lift",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LabelTypeLiftGraphQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LabelTypeLiftGraphQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fb374e5e8be419497ffaf3a82c19258c",
    "id": null,
    "metadata": {},
    "name": "LabelTypeLiftGraphQuery",
    "operationKind": "query",
    "text": "query LabelTypeLiftGraphQuery(\n  $input: GetAISummaryRequest!\n  $skip: Boolean!\n) {\n  getLabelLiftByType(input: $input) @skip(if: $skip) {\n    labelType\n    lift\n  }\n}\n"
  }
};
})();

(node as any).hash = "ee52394cc47b0d7de4be1bb66bbfc863";

export default node;
